module.exports = __webpack_public_path__ + "img/finance-application-display-chevy.5142caf9.png";